export const simPrimariaFilterButtons = [
    {text: "Numero di telefono", value: "msisdn"},
    {text: "Numero seriale", value: "iccId"}
]
export const filterPrimaria = {
    msisdn: {
        label: "Numero di telefono",
        value: "",
    },
    iccId: {
        label: "Numero seriale",
        value: "",
    },
}
